
import { BonusSection, LegacyBonusSection, LegacyBonusItem } from '@/types/analysisTypes';
import { isNewBonusFormat } from '@/utils/bonus-section';

/**
 * Format a key for display
 */
export function formatInsightName(key: string): string {
  return key.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
}

/**
 * Checks if an insight section has content
 */
export function hasContent(key: string, bonusSection: BonusSection): boolean {
  const insight = bonusSection[key as keyof typeof bonusSection];
  if (!insight) return false;
  
  if (isNewBonusFormat(bonusSection)) {
    // For new format, check if any required fields have content
    const newBonusSection = bonusSection as any; // Using any to handle dynamic properties
    
    switch (key) {
      case 'expert_insight': {
        const expertInsight = newBonusSection.expert_insight;
        return !!(expertInsight.title || expertInsight.intro || 
                 (expertInsight.key_takeaways && expertInsight.key_takeaways.length > 0));
      }
      case 'unexpected_analogy': {
        const analogy = newBonusSection.unexpected_analogy;
        return !!(analogy.title || analogy.intro || 
                 (analogy.key_points && analogy.key_points.length > 0));
      }
      case 'challenged_assumption': {
        const assumption = newBonusSection.challenged_assumption;
        return !!(assumption.title || assumption.intro || 
                 (assumption.key_reasons && assumption.key_reasons.length > 0));
      }
      case 'insider_tip': {
        const tip = newBonusSection.insider_tip;
        return !!(tip.title || tip.intro || 
                 (tip.step_by_step && tip.step_by_step.length > 0));
      }
      default:
        return false;
    }
  } else {
    // For old format, check if question or example exists
    const legacySection = bonusSection as LegacyBonusSection;
    const legacyItem = insight as LegacyBonusItem;
    return !!(legacyItem && typeof legacyItem === 'object' && 
             (legacyItem.question || legacyItem.example));
  }
}
